import './CustomPrompt.css';

export default function PromptPreview({ text }) {
  if (!text) return null;
  return (
    <div className="cp-prompt-preview">
      <span className="cp-suggestions-label">Prompt Preview</span>
      <textarea
        className="cp-textarea cp-textarea--readonly"
        readOnly
        value={text}
      />
    </div>
  );
}
